module.exports = __webpack_public_path__ + "65c6eeb61149f289c1e923b9d563f95b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icon.svg
// module id = VYO7
// module chunks = 0